import Vue from "vue";
import "normalize.css/normalize.css";
import Element from "element-ui";
import "./styles/element-variables.scss";
import "@/styles/index.scss";
import App from "./App";
import store from "./store";
import router from "./router";
import "./icons";
import "@/iconfont/iconfont.js";
import "./permission";
import { showLoading, hideLoading } from "@/utils/globalLoading";
import * as filters from "./filters";
import { copyContent } from "./utils/index";
import CanvasPoster from "vue-canvas-poster";
import autoRefresh from "@/utils/autoFlash";
import { hasPermission } from "@/permission";
import { renderHeader } from "@/utils/table.js";
import searchList from "@/static/searchList";
import { regMap } from "@/static/reg";
import formRules from "./static/formRules";
import inputFilter from "@/directive/inputFilter";
import perms from "@/directive/perms";

Vue.use(CanvasPoster);

// 全局混入
Vue.mixin({
  computed: {
    G_renderHeader() {
      return renderHeader;
    },
    routePath() {
      return this.$route.path;
    },
    routePerms() {
      const list = this.$route.path.split("/");
      list.splice(0, 1);
      return list.join(":");
    },
    G_searchList() {
      return searchList;
    },
    G_map() {
      return searchList.map;
    }
  },
  methods: {
    cleanHtmlStyle(v) {
      return v
        .replace(/<style[^>]*>.*?<\/style>/gis, "")
        .replace(/\sstyle=["'][^"']*["']/gi, "")
        .replace(/\sclass=["'][^"']*["']/gi, "");
    },
    hasPerms(key) {
      return hasPermission(this.routePerms + ":" + key);
    },
    routerGo(path, query) {
      router.push({ path, query });
    },
    windowOpen(url) {
      window.open(url);
    },
    filterInput(e, { target, key, reg, type }) {
      const R = regMap.get(type) || reg;
      if (R && e && key) {
        const result = e.replace(R, "");
        target ? this.$set(target, key, result) : (this[key] = result);
      }
    }
  }
});
Vue.prototype.$formRules = formRules;

Vue.use(Element, {
  size: "medium"
});

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

Vue.directive("removeAriaHidden", {
  bind(el) {
    const ariaEls = el.querySelectorAll(".el-radio__original");
    ariaEls.forEach(item => {
      item.removeAttribute("aria-hidden");
    });
  }
});

Vue.directive("inputFilter", inputFilter);
Vue.directive("perms", perms);

Vue.prototype.$copy = copyContent;

Vue.prototype.$showLoading = showLoading;
Vue.prototype.$hideLoading = hideLoading;

new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
});

const env = process.env.NODE_ENV;
env === "production" && autoRefresh();
